import { render, staticRenderFns } from "./TabTermsOfPaymentComponent.vue?vue&type=template&id=1e184046&scoped=true"
import script from "./TabTermsOfPaymentComponent.vue?vue&type=script&lang=js"
export * from "./TabTermsOfPaymentComponent.vue?vue&type=script&lang=js"
import style0 from "./TabTermsOfPaymentComponent.vue?vue&type=style&index=0&id=1e184046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e184046",
  null
  
)

export default component.exports